export class AcquireTokenPopupError extends Error {
  public name: string;

  constructor(message: string) {
    super(message);

    this.name = 'AcquireTokenPopupError';

    Object.setPrototypeOf(this, AcquireTokenPopupError.prototype);
  }
}
